import Collection from './generic/collection'
import { onAjaxContentLoaded } from "./generic/evented";
import { getCfg } from '../js/utils/getCfg'
import Modals from '../js/modals'

class DetailProductModal {
  static selectors = {
    modalTemplate: '[data-js-detail-product-modal-template]',
    img: '[data-js-detail-product-modal-img]',
    name: '[data-js-detail-product-modal-name]',
    price: '[data-js-detail-product-modal-price ]',
    btnOpen: '[data-js-detail-product-modal-btn-open]',
    desc: '[data-js-detail-product-modal-description]',
    btnSubmit: '[data-js-detail-product-modal-submit-btn]',
    stoneInput: '[data-js-detail-product-stone-input]',
    addToCart: '[data-js-detail-product-add-to-cart]',
  }

  constructor(instance) {
    this.instance = instance
    this.cfg = getCfg(this.instance, DetailProductModal.selectors.btnOpen)
    this.bindEvents()
  }

  showModal() {
    $.fancybox.close();
    const template = this.createTemplate(this.cfg)
    Modals.openHtmlModal(template, {})
  }

  createTemplate(cfg) {
    const template = document.querySelector(DetailProductModal.selectors.modalTemplate).content.cloneNode(true);
    const getElFromTemplate = (elName) => {
      return template.querySelector(DetailProductModal.selectors[elName])
    }

    getElFromTemplate("img").src = cfg?.img
    getElFromTemplate("name").textContent = cfg?.name
    getElFromTemplate("price").textContent = cfg?.price
    const stoneInput = getElFromTemplate("stoneInput")
    stoneInput?.setAttribute("value", cfg?.btnSubmit?.stoneId)
    const addToCartBtn = getElFromTemplate("addToCart")
    addToCartBtn?.setAttribute("data-js-add-to-cart", cfg?.btnSubmit?.stoneId)

    const desc = getElFromTemplate("desc")
    desc.innerHTML = ""
    Object.entries(cfg?.detail).forEach(([key, val]) => {
      const parent = document.createElement("div")
      const dt = document.createElement("dt")
      const dd = document.createElement("dd")
      const hr = document.createElement("div")
      parent.classList.add("product-modal__description-row")
      hr.classList.add("product-modal__hr")
      dt.innerText = key
      dd.innerText = val
      parent.appendChild(dt)
      parent.appendChild(dd)
      desc.appendChild(parent)
      desc.appendChild(hr)
    })

    return template
  }


  bindEvents() {
    this.instance.addEventListener('click', (e) => this.showModal(e))
  }
}

export class DetailProductModalCollection extends Collection {
  static selectors = {
    instance: '[data-js-detail-product-modal-btn-open]',
  }

  constructor() {
    super(DetailProductModalCollection.selectors.instance, DetailProductModal)
    this.init();
    this.bindEvents();
  }

  bindEvents () {
    onAjaxContentLoaded(() => {
      this.init()
    })
  }

  init() {
    $(DetailProductModalCollection.selectors.instance).each((index, el) => {
      this.collection = new DetailProductModal(el)
    })
  }
}
